import { computed, ref } from "vue";
import { defineStore } from "pinia";

import type { TenantConsoleAccount, TenantSummary } from "@/types/auth";

export const useAuthStore = defineStore("tenant_console_auth", () => {
  const account = ref<TenantConsoleAccount | null>(null);
  const tenant = ref<TenantSummary | null>(null);

  const setAuthContext = (nextAccount: TenantConsoleAccount, nextTenant: TenantSummary) => {
    account.value = nextAccount;
    tenant.value = nextTenant;
  };

  const clearAuthContext = () => {
    account.value = null;
    tenant.value = null;
  };

  const isAuthenticated = computed(() => Boolean(account.value && tenant.value));
  const isOwner = computed(() => account.value?.role === "owner");
  const isDemo = computed(() => tenant.value?.isDemo ?? false);

  return {
    account,
    tenant,
    setAuthContext,
    clearAuthContext,
    isAuthenticated,
    isOwner,
    isDemo,
  };
}, {
  persist: {
    key: "tenant_console_auth",
    storage: localStorage,
    paths: ["account", "tenant"],
  },
});
